<div [ngClass]="{'m-t m-t-3-s bg-col-51-x bg-col-51-l p-a-10 p-a-0-s' : !rightView}">

    <div [ngClass]="{'m-b-8' : rightView, 'flex-s flex-m' : rightView && (iconsSections?.length < 4)}"
         class="flex-x flex-l">
        @for (item of iconsSections; track item; let isLast = $last) {
        <div class="center"
             [ngClass]="{
                'm-r-0': isLast,
                'w-6 m-t-10 m-b-2': rightView,
                'flex-span-1 c-3-set-x c-3-set-l c-6-set-m c-6-set-s m-t-3 m-t-7-s m-b-7 m-b-2-s' : !rightView
                }">
            <div class="ratio-1-1 w-3-s"
                 [style.width.rem]="client.isS || client.isM || rightView  ? 2.5 : 4">
                <img class="fill"
                     [image]="item.image" />
            </div>
            <div [ngClass]="rightView ? 'm-t-2' : 'm-t-3 m-t-2-s'">
                <span class="s1"
                      [innerHTML]="item.attribute.label"></span>:
                <span class="p1"
                      [innerHTML]="item.attribute.valuesLabels"></span>
                @if (item.attribute.code != 'weight' && item.attribute.code != 'webweight') {
                <span class="p1">{{'cm' | translate}}
                </span>
                }
                @if (item.attribute.code == 'weight' || item.attribute.code == 'webweight') {
                <span class="p1">{{'kg' | translate}}
                </span>
                }
            </div>
        </div>
        }
    </div>
    <div class="flex flex-justify-between m-t-4-s">
        @for (attribute of displayedTopAttributes; track attribute) {
        <div [ngClass]="{'p-b-6 p-b-0-s p-t-6-s' : rightView}">
            <span class="p2">
                @if (!isPDF(attribute.valuesLabels[0])) {
                <span [innerHTML]="attribute.valuesLabels"></span>
                }
                @if (isPDF(attribute.valuesLabels[0])) {
                <href [hrefTarget]="'_blank'"
                      [link]="attribute.valuesLabels[0]">{{'Download' | translate }}</href>
                }
                @if (attribute.code == 'width' || attribute.code == 'depth' || attribute.code == 'height') {
                <span>{{'cm'
                    | translate}}</span>
                }
            </span>
        </div>
        }
    </div>
    <div class="m-r-0-s m-t-4-s m-b-5 m-b-0-m m-b-0-s">
        @for (item of dimensionsSections; track item; let i = $index) {
        <div class="m-b-5-x m-b-5-l">
            <div class="p-b p-t b-b b-col-4 cursor-pointer flex flex-justify-between flex-middle"
                 [zippyToggle]="zippyNamePrefix + i">
                <span class="h4"
                      [innerHTML]="item.title"></span>
                <i class="p-r-1 p-t-2"
                   [zippyName]="zippyNamePrefix + i"
                   zippyClass="flip"
                   class="indicator icon-chevron-up m-r-1"></i>
            </div>
            <div class="hide-up-container">
                <div class="ng-hide-animate hide-up _hide-up-200"
                     [zippy]="zippyNamePrefix + i"
                     [zippyState]="true">
                    @for (attribute of item.attributes; track attribute) {
                    <div class="p-t p-b p-t-3-m p-b-3-m p-t-3-s p-b-3-s b-b b-col-4"
                         [ngClass]="{'p-t-3 p-b-3' : rightView}">
                        <p class="c-5 m-r-0-x m-r-0-l m-b-0 p-r"
                           sizeClass="SM:s2, XL:s1"
                           [innerHTML]="attribute.label"></p>
                        <p class="c-7 m-r-0 m-b-0"
                           sizeClass="SM:p2, XL:p1">
                            @if (!isPDF(attribute.valuesLabels[0])) {
                            <span [innerHTML]="attribute.valuesLabels"></span>
                            }
                            @if (isPDF(attribute.valuesLabels[0])) {
                            <href [hrefTarget]="'_blank'"
                                  [link]="attribute.valuesLabels[0]">{{'Download' | translate }}</href>
                            }
                            @if (attribute.code == 'width' || attribute.code == 'depth' || attribute.code == 'height') {
                            <span>{{'cm'
                                | translate}}</span>
                            }
                        </p>
                    </div>
                    }
                </div>
            </div>
        </div>
        }
    </div>
</div>
